import { render, staticRenderFns } from "./CallDetailsCompleted.vue?vue&type=template&id=a81b4440&"
import script from "./CallDetailsCompleted.vue?vue&type=script&lang=js&"
export * from "./CallDetailsCompleted.vue?vue&type=script&lang=js&"
import style0 from "./CallDetailsCompleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports